import React from 'react';
import { motion } from 'framer-motion';
export function ExpertEndorsement() {
  return <section className="py-16 bg-[#9CAF88]/10 px-4" data-id="element-43">
      <div className="max-w-4xl mx-auto text-center" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border-y-2 border-[#9CAF88]/30 py-10" data-id="element-45">
          <p className="text-2xl md:text-3xl font-serif italic text-[#5C4033] mb-6" data-id="element-46">
            “La sabiduría popular bien aplicada puede ser más efectiva que
            muchas soluciones modernas.”
          </p>
          <p className="text-[#8B7355] font-medium tracking-wide uppercase text-sm" data-id="element-47">
            Especialista en bienestar y hábitos saludables
          </p>
        </motion.div>
      </div>
    </section>;
}